$(document).ready(function() {

  if ($('section.profile').length) {
    displayProfileProgressCircle();
  }

  function displayProfileProgressCircle() {
    // Fill profile percentage from data attribute
    if ($('.profile-progress')) {
      var percentFilled = $('.profile-progress').data('profile-progress');
      $('.circle-chart-circle-negative').attr('stroke-dasharray', percentFilled+",100");
      $('.circle-chart-info text').text(percentFilled+"%");
      $('.circle-chart').show();
    }
  }

});
